import Cookies from 'js-cookie';

import { getPostHogBootstrapCookieName } from '@/common/constants';
import type { BootstrapCookie } from '@/lib/analytics/visitor-id';

export function readBootstrapCookie(): BootstrapCookie | null {
  const value = Cookies.get(getPostHogBootstrapCookieName());
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}
